import React from 'react';
import { Paper, Typography, Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const BottomNav = () => {
    const { currentUser } = useAuth();

    return (
        <Paper
            component="footer"
            sx={{
                borderTop: 1,
                borderColor: 'divider',
                backgroundColor: '#fff',
                display: { xs: 'block', md: 'none' },
                width: '100%',
                boxShadow: '0 -2px 4px rgba(0,0,0,0.05)',
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000
            }}
            elevation={3}
        >
            <Box
                sx={{
                    py: { xs: 1, sm: 1.5 },
                    px: { xs: 1, sm: 2 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: { xs: 2, sm: 3 },
                        mb: { xs: 0.5, sm: 1 },
                        flexWrap: 'wrap',
                        alignItems: 'center'
                    }}
                >
                    {!currentUser && (
                        <Link
                            component={RouterLink}
                            to="/register"
                            sx={{
                                fontSize: { xs: '0.8rem', sm: '0.85rem' },
                                fontWeight: 500,
                                color: '#3498db',
                                textDecoration: 'none',
                                px: 1.5,
                                py: 0.3,
                                borderRadius: '8px',
                                background: 'rgba(52, 152, 219, 0.1)',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    background: 'rgba(52, 152, 219, 0.15)',
                                    color: '#2980b9'
                                }
                            }}
                        >
                            無料登録
                        </Link>
                    )}
                    <Link
                        component={RouterLink}
                        to="/create-listing"
                        sx={{
                            fontSize: { xs: '0.8rem', sm: '0.85rem' },
                            fontWeight: 500,
                            color: '#3498db',
                            textDecoration: 'none',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                transform: 'translateY(-1px)',
                                color: '#2980b9'
                            }
                        }}
                    >
                        物件掲載
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/guide"
                        color="primary"
                        underline="hover"
                        sx={{
                            fontSize: { xs: '0.8rem', sm: '0.85rem' },
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                transform: 'translateY(-1px)',
                                color: '#2980b9'
                            }
                        }}
                    >
                        使い方
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/help"
                        color="primary"
                        underline="hover"
                        sx={{
                            fontSize: { xs: '0.8rem', sm: '0.85rem' },
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                transform: 'translateY(-1px)',
                                color: '#2980b9'
                            }
                        }}
                    >
                        ヘルプ
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/blog"
                        color="primary"
                        underline="hover"
                        sx={{
                            fontSize: { xs: '0.8rem', sm: '0.85rem' },
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                transform: 'translateY(-1px)',
                                color: '#2980b9'
                            }
                        }}
                    >
                        ブログ
                    </Link>
                </Box>
                <Typography
                    variant="caption"
                    color="text.secondary"
                    align="center"
                    sx={{
                        fontSize: { xs: '0.75rem', sm: '0.8rem' },
                        fontWeight: 500,
                        letterSpacing: '0.02em'
                    }}
                >
                    © {new Date().getFullYear()} Room Share Matching. All rights reserved.
                </Typography>
            </Box>
        </Paper>
    );
};

export default BottomNav; 